import {
  createContext,
  Dispatch,
  MutableRefObject,
  ReactElement,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react'

import { InvoiceEditorVariant } from '../enums/invoiceEditorVariant'
import { InvoiceEditorView } from '../enums/invoiceEditorView'

interface ContextState {
  invoiceEditorVariant: InvoiceEditorVariant
  isAppearanceSettingsDirtyRef: MutableRefObject<boolean>
  setView: Dispatch<SetStateAction<InvoiceEditorView>>
  view: InvoiceEditorView
}

const InvoiceEditorContext = createContext<ContextState | undefined>(undefined)

interface InvoiceEditorContextProps {
  children: ReactNode
  invoiceEditorVariant: InvoiceEditorVariant
}

export const InvoiceEditorContextProvider = ({
  children,
  invoiceEditorVariant,
}: InvoiceEditorContextProps): ReactElement => {
  const [view, setView] = useState(InvoiceEditorView.Editor)
  const isAppearanceSettingsDirtyRef = useRef(false)

  const contextValue = useMemo(
    () => ({ invoiceEditorVariant, isAppearanceSettingsDirtyRef, setView, view }),
    [invoiceEditorVariant, isAppearanceSettingsDirtyRef, setView, view],
  )

  return <InvoiceEditorContext.Provider value={contextValue}>{children}</InvoiceEditorContext.Provider>
}

export const useInvoiceEditor = () => {
  const context = useContext(InvoiceEditorContext)

  if (!context) {
    throw new Error('InvoiceEditorContextProvider is missing in the module!')
  }

  return context
}
